"use strict";

if (!RedactorPlugins) var RedactorPlugins = {};

RedactorPlugins.fontsize = function () {
    return {
        init: function () {
            var fontSizes = [10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 36, 40, 45, 50, 55, 60, 66, 72, 78, 85, 92, 100];
            var that = this;
            var dropdown = {};

            $.each(fontSizes, function (i, s) {
                dropdown['s' + i] = {
                    title: s, func: function () {
                        that.fontsize.set(s);
                    }
                };
            });

            var button = this.button.add('fontsize', this.lang.get('fontsize'));
            this.button.addDropdown(button, dropdown);
        },

        set: function (size) {
            this.inline.format('span', 'style', 'font-size: ' + Fotobook.book.getSizeInEm(size));

            this.code.sync();
            this.$editor.trigger('keyup');
        },

        reset: function () {
            this.inline.removeStyleRule('font-size');
        },
    };
};